import { http } from "@/v2/repo/http";
import { IRepoErrors } from "@/v2/repo/errors";
import { ICreateVoidReasonRequest, ICreateVoidReasonBodyParams } from "./types";

export class CreateVoidReasonError extends Error {
  errors: IRepoErrors;

  constructor(errors: IRepoErrors) {
    super("Error in repo: CreateVoidReasonError");
    this.errors = errors;
    this.name = this.constructor.name;
  }
}

/**
 * {@link https://chatfood.stoplight.io/docs/chatfood-api-dashboard/692e9c5230b7a-create-void-reason API contract}
 */
export async function createVoidReason(
  request: ICreateVoidReasonRequest
): Promise<void> {
  try {
    const params: ICreateVoidReasonBodyParams = {
      reason: request.reason,
    };

    await http.post(
      `api/v3/businesses/${request.businessId}/tabs/void-categories/${request.voidCategoryId}/reasons`,
      params
    );
  } catch (e: any) {
    const error: IRepoErrors<null> = {};
    const isAxiosError = Boolean(e?.isAxiosError);

    if (!isAxiosError) {
      throw e;
    }

    throw new CreateVoidReasonError(error);
  }
}
